



import {Component, Prop, Vue} from 'vue-property-decorator';

const StepDefinition = () => import('@/components/Molecules/StepDefinition/StepDefinition.vue')
const StepHowTo = () => import('@/components/Molecules/StepHowTo/StepHowTo.vue')
const StepMedia = () => import('@/components/Molecules/StepMedia/StepMedia.vue')
const StepFullName = () => import('@/components/Molecules/StepFullName/StepFullName.vue')

import {MediaInterface, MilestoneInterface} from "@/share/types/interface";
import {GROW_TREE_MODAL_TYPE} from "@/constants";

@Component({
  components: {
    StepDefinition,
    StepHowTo,
    StepMedia,
    StepFullName
  }
})
export default class StepCardInfoContent extends Vue {
  @Prop({required: false, type: String}) categorySrc !: string
  @Prop({type: Boolean, default: false}) value !: boolean
  @Prop({type: Boolean, default: false}) disabled !: boolean
  @Prop({type: Boolean, default: false}) isResult?: boolean
  @Prop({type: Number, default: GROW_TREE_MODAL_TYPE.STEP}) type!: number
  @Prop() milestone!: MilestoneInterface
  @Prop() medias?: MediaInterface[]

  private get collapseId(): string {
    if (this.isResult) return `collapse-result${this.milestone.id}`
    return ''
  }
}
